import React, { useEffect, useState } from 'react';

import { getProducts } from '../../../api/services/productsApi';

import ProductCard from '../../../components/main/cards/ProductCard/ProductCard';
import hero from '../../../images/products/PEWI-225 1.webp';

import './Products.css';

const Products = () => {
  const [products, setProducts] = useState([]);
  useEffect(function () {
    const getAllProducts = async () => {
      const allProducts = await getProducts();
      setProducts(allProducts);
    };
    getAllProducts();
  }, []);

  return (
    <div className='product__page'>
      <div className='product__img'>
        <img src={hero} alt='' className='hero__img' />
      </div>
      <div className='product-page-content-container'>
        <div>
          <h1 className='product__title'>OUR PRODUCTS</h1>
        </div>
        <div className='product-subtitle-container'>
          <span className='product__subtitle'>
            For more information and price on products, please contact us
            directly
          </span>
        </div>
        <div className='product__cardGroup'>
          {products.map((p) => (
            <div key={p._id} className='product__card'>
              <ProductCard
                title={p.name}
                desc={p.description}
                image={p.imageUrl}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Products;
